module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getListData
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getListData($event)
      }
    },
    model: {
      value: (_vm.filters.Name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Name", $$v)
      },
      expression: "filters.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "选择或搜索门店"
    },
    model: {
      value: (_vm.TenancyId),
      callback: function($$v) {
        _vm.TenancyId = $$v
      },
      expression: "TenancyId"
    }
  }, _vm._l((_vm.optionsShop), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "1702px"
    },
    attrs: {
      "data": _vm.List,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "队伍中文全称",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ShortName",
      "label": "队伍中文简称",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PhoneticName",
      "label": "首字母简称",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Citizenship",
      "label": "国籍",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AreaCode",
      "label": "区号",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "TeamType",
      "label": "队伍类型",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Unit",
      "label": "开票单位名称",
      "width": "140",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "TaxNumber",
      "label": "税号",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v("当前有" + _vm._s(_vm.Count) + "个队伍")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.Count
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d2b3a21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Competition/TeamList.vue
// module id = 1349
// module chunks = 1